import {defineMessages} from 'react-intl';

export default defineMessages({
	search: {
		id: 'forms.fields.search.label',
		defaultMessage: 'Search',
	},
	cancel: {
		id: 'forms.fields.search.cancel',
		defaultMessage: 'CANCEL'
	},
	viewAll: {
		id: 'flyouts.quickSearch.viewAll',
		defaultMessage: 'ALL RESULTS ({total})'
	}
});
